/**
 * Health Orb — a pulsing, glowing indicator of system health.
 * NOT a static dot. Premium dashboards make health feel ALIVE.
 */
export default function HealthOrb({ status, size = 'sm', ariaLabel }) {
  const sizeMap = { sm: 'w-2.5 h-2.5', md: 'w-3.5 h-3.5', lg: 'w-5 h-5' }
  const glowSizeMap = { sm: 'inset-[-4px]', md: 'inset-[-6px]', lg: 'inset-[-8px]' }

  const config = {
    healthy:  { color: '#22C55E', glow: 'rgba(34,197,94,0.35)', pulse: 'animate-health-pulse', glowAnim: 'animate-health-glow' },
    degraded: { color: '#F59E0B', glow: 'rgba(245,158,11,0.30)', pulse: 'animate-health-pulse-slow', glowAnim: 'animate-health-glow' },
    down:     { color: '#EF4444', glow: 'rgba(239,68,68,0.40)', pulse: 'animate-health-pulse-fast', glowAnim: 'animate-health-glow' },
  }

  const c = config[status] || config.down

  return (
    <span
      className={`relative inline-flex items-center justify-center ${sizeMap[size]}`}
      aria-label={ariaLabel}
    >
      {/* Glow halo */}
      <span
        className={`absolute ${glowSizeMap[size]} rounded-full ${c.glowAnim}`}
        style={{ background: c.glow }}
      />
      {/* Core dot */}
      <span
        className={`relative z-10 w-full h-full rounded-full ${c.pulse}`}
        style={{ backgroundColor: c.color }}
      />
    </span>
  )
}
